import { HelpCircleIcon } from 'lucide-react'

import { useEmbeddedOnboarding } from 'components/hooks/employer_onboarding/useEmbeddedOnboarding'
import { Modal, TextButton, TextLink } from 'slab'

import { EmbeddedSupportLinkContent } from './EmbeddedSupportLinkContent'

const SALES_LINK = 'https://thatch.com/onboarding/get-support'

export function SupportLink () {
  const { isEmbedded } = useEmbeddedOnboarding()

  return (
    <Modal
      trigger={
        <TextButton
          onClick={() => {
            window.segment?.track('[ER] AllowanceTool get help opened', {
              url: window.location.href,
              isEmbedded,
            })
          }}
          leftIcon={HelpCircleIcon}
        >
          Get support
        </TextButton>
      }
      width='small'
      aria-describedby={undefined}
    >
      <Modal.Header>
        <Modal.Title>Get support</Modal.Title>
      </Modal.Header>
      {isEmbedded
        ? <EmbeddedSupportLinkContent />
        : (
          <Modal.Body>
            <div>
              <div className='pb-2'>
                <h3 className='body-bold mb-1'>Want to talk to someone?</h3>
                <p>
                  <TextLink
                    href={SALES_LINK}
                    onClick={() => {
                      window.segment?.track('[ER] AllowanceTool get support link clicked', {
                        url: window.location.href,
                      })
                    }}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Book a call with a member of our team.
                  </TextLink>
                </p>
              </div>
            </div>
          </Modal.Body>
          )}
    </Modal>
  )
}
